// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"27":"BuyerLazyComponent","795":"IntroVideoModal"}[chunkId] + "." + {"27":"d5c41eb271a514f46c33","795":"59ed0c4083d39d6477a6"}[chunkId] + ".css";
};